import { render, staticRenderFns } from "./ImportsSidebar.vue?vue&type=template&id=954d67ce&"
import script from "./ImportsSidebar.vue?vue&type=script&lang=js&"
export * from "./ImportsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ImportsSidebar.vue?vue&type=style&index=0&id=954d67ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports